// import store from '@/store';
// import { getExamTypes } from "@/api/realTest";

export const menuDatas = {
  // 学生
  student: [
    {
      name: "学习中心",
      icon: "iconfangkuailiebiao",
      children: [
        {
          name: "课程计划",
          code: "course"
        },
        // {
        //   name: "我的作业",
        //   code: "practice",
        //   // "code": "startPractice",
        // },
        // {
        //   name: "教材版本",
        //   code: "textbookVersions",
        // },
        {
          name: "专业计划",
          code: "majorPlan"
        } /* , {
                "name": "免费视频",
                "code": "videoCenter",
            } */
      ]
    },
    {
      name: "学习记录",
      icon: "iconboshimao1",
      children: [
        {
          name: "听课记录",
          code: "classRecord",
        },
        {
          name: "做题记录",
          code: "problemRecord",
        },
        {
          name: "易错题集",
          code: "errorRecord",
        },
        {
          name: "我的收藏",
          code: "myCollect",
        },
        {
          name: "我的笔记",
          code: "myNotes",
        }
      ]
    },
    {
      name: "练习中心",
      icon: "iconbianzu",
      children: [
        {
          name: "智能练习",
          code: "allTest"
        },
        {
          name: "章节练习",
          code: "allTest"
        }
      ]
    },
/*    {
      name: "考试中心",
      icon: "iconkaoshi",
      children: [
        {
          name: "考试报名",
          code: "examCenter"
        },
        {
          name: "考前模拟",
          code: "realTestStart"
        },
        {
          name: "我的考试",
          code: "participateTest"
        }
      ]
    },*/
    {
      name: "个人中心",
      icon: "iconshuben",
      children: [
        {
          name: "个人信息",
          code: "informationData"
        },
        /*{
          name: "我的班级",
          code: "myClassData"
        },*/
        {
          name: "我的成绩",
          code: "myGradesData"
        },/*,
        {
          name: "我的证书",
          code: "myCertificateData"
        }*/


        {
          name: "我的课表",
          code: "curriculum"
        },
        {
          name: "我的课程",
          code: "courseList"
        },
        {
          name: "毕业论文",
          code: "graduation"
        },
        {
          name: "前置学历",
          code: "preEducation"
        },
        {
          name: "答辩申请",
          code: "reply"
        },
        {
          name: "学位",
          code: "academicDegree"
        }
      ]
    },
    {
      name: "消息中心",
      icon: "iconbiaoji1",
      children: [
        {
          name: "我的消息",
          code: "studentMessageCenter"
        },
        {
          name: "投诉建议",
          code: "options"
        },
        {
          name: "公告通知",
          code: "studentNotices"
        },
        {
          name: "校长信箱",
          code: "mailbox"
        }
      ]
    }
  ],
  // 上课老师
  shangke: [
    {
      name: "授课信息",
      icon: "iconicon-test1",
      children: [
        {
          name: "授课信息",
          code: "classInformation"
        }
      ]
    },
    {
      name: "消息中心",
      icon: "iconxiaoxi",
      children: [
        {
          name: "群发消息",
          code: "messageCenter"
        },
        {
          name: "系统消息",
          code: "systemMessage"
        },
        {
          name: "院校消息",
          code: "academyMessage"
        }
      ]
    },
    // {
    //       "name": "院校消息",
    //       "icon": 'icontousujianyi',
    //       "children": [{
    //           "name": "投诉处理",
    //           "code": "3_personalise",
    //       }, {
    //           "name": "消息反馈",
    //           "code": "3_personalise",
    //       }, {
    //           "name": "院校消息",
    //           "code": "academyMessage"
    //       }]
    //   },
    {
      name: "个人信息",
      icon: "iconshuben",
      children: [
        {
          name: "个人信息",
          code: "personalDetail"
        },
      ]
    }
  ],
  // 阅卷老师
  yuejuan: [
    {
      name: "阅卷中心",
      icon: "iconyuejuanzhongxin",
      children: [
        {
          name: "所有阅卷",
          code: "allMarkingData"
        }
      ]
    },
    {
      name: "试卷中心",
      icon: "iconbiaoji1",
      children: [
        {
          name: "所有试卷",
          code: "allThePapers"
        }
      ]
    },
  ],
  // 班主任
  banzhuren: [
    {
      name: "班级管理",
      icon: "iconicon-test1",
      children: [
        {
          name: "班级信息",
          code: "classInfo"
        },
        {
          name: "班务信息",
          code: "classBusinessInfo"
        }
      ]
    },
    {
      name: "消息中心",
      icon: "iconxiaoxi",
      children: [
        {
          name: "群发消息",
          code: "messageCenter"
        },
        {
          name: "系统消息",
          code: "systemMessage"
        },
        {
          name: "院校消息",
          code: "academyMessage"
        }
      ]
    },
    // , {
    //     "name": "投诉建议",
    //     "icon": 'icontousujianyi',
    //     "children": [{
    //         "name": "投诉处理",
    //         "code": "3_personalise",
    //     }, {
    //         "name": "消息反馈",
    //         "code": "3_personalise",
    //     }]
    // },
    {
      name: "个人信息",
      icon: "iconshuben",
      children: [
        {
          name: "个人信息",
          code: "personalDetail"
        }
      ]
    }
  ],
  //  阅卷督察
  ducha: [
    {
      name: "试卷中心",
      icon: "iconbiaoji1",
      children: [
        {
          name: "所有试卷",
          code: "allThePapers"
        }
      ]
    },
    {
      name: "消息中心",
      icon: "iconxiaoxi",
      children: [
        {
          name: "系统消息",
          code: "systemMessage"
        },
        {
          name: "院校消息",
          code: "academyMessage"
        },
        {
          name: "学生消息",
          code: "studentMessage"
        }
      ]
    },
    {
      name: "个人信息",
      icon: "iconshuben",
      children: [
        {
          name: "个人信息",
          code: "personalDetail"
        }
      ]
    }
  ]
};
